// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --ion-background-color: var(--planeed-color-white);
}

.content {
  padding: 35px;
  color: var(--ion-color-text-color);
}
.content span {
  font-weight: bold;
  color: var(--ion-color-text-color);
}
.content p {
  color: var(--ion-color-text-color);
  padding-left: 15px;
}
.content .statistics-btn {
  width: 100%;
}
.content img {
  height: 50px;
}

.sdg-modal-row {
  display: flex;
  align-items: center;
  justify-content: left;
  padding-bottom: 20px;
}

.text-center {
  padding-top: 15px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
